import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { AntennaActivityLog } from '../activity/AntennaActivityLog';
import { Stack } from '@mui/material';
import { ActivityIcon } from '@app/activity/ActivityIcon';

export function DashboardActivityLog() {
    return (
        <Stack>
            <Box display="flex" alignItems="center" mb={1}>
                <Box mr={1} display="flex">
                    <ActivityIcon />
                </Box>
                <Typography variant="h5" color="textSecondary">
                    Latest Activity
                </Typography>
            </Box>
            <Card sx={{ mb: 2, px: 2 }}>
                <AntennaActivityLog pageSize={10} />
            </Card>
        </Stack>
    );
}
